import { Mail, Phone } from 'lucide-react';
import { useSiteContent } from '@personal-portfolio/queries';
import { LinkButton } from '@/shared/ui/button';

interface QuickContactCardProps {
  email?: string | null;
  phone?: string | null;
}

/**
 * Quick contact block for the right sidebar. Renders nothing unless at
 * least one contact method is available.
 */
export function QuickContactCard({ email, phone }: QuickContactCardProps) {
  const content = useSiteContent();
  if (!email && !phone) return null;

  return (
    <div className="space-y-4">
      <h3 className="font-mono text-xs font-medium tracking-widest text-muted-foreground uppercase">
        {content.chrome.quickContact}
      </h3>
      <div className="space-y-2">
        {email && (
          <LinkButton
            variant="ghost"
            size="sm"
            className="w-full min-w-0 justify-start"
            href={`mailto:${email}`}
          >
            <Mail className="mr-2 h-4 w-4" />
            <span className="min-w-0 truncate">{email}</span>
          </LinkButton>
        )}
        {phone && (
          <LinkButton
            variant="ghost"
            size="sm"
            className="w-full min-w-0 justify-start"
            href={`tel:${phone}`}
          >
            <Phone className="mr-2 h-4 w-4" />
            <span className="min-w-0 truncate">{phone}</span>
          </LinkButton>
        )}
      </div>
    </div>
  );
}
